import { PaySupplementAvailablePaymentTypeEnum } from "@oysterhr/schema"

export enum PaymentSchedule {
  OneTime = "oneTime",
  Recurring = "recurring",
}

export const AvailablePaySupplementLabels: Record<
  Exclude<
    PaySupplementAvailablePaymentTypeEnum,
    PaySupplementAvailablePaymentTypeEnum.DisabilityInsurance
  >,
  string
> = {
  [PaySupplementAvailablePaymentTypeEnum.Bonus]: "labels.BONUS",
  [PaySupplementAvailablePaymentTypeEnum.Commission]: "labels.COMMISSION",
  [PaySupplementAvailablePaymentTypeEnum.EmployerPensionRetirementContribution]:
    "labels.EMPLOYER_PENSION_RETIREMENT_CONTRIBUTION",
  [PaySupplementAvailablePaymentTypeEnum.HealthAndWellbeingAllowance]:
    "labels.HEALTH_AND_WELLBEING_ALLOWANCE",
  [PaySupplementAvailablePaymentTypeEnum.HealthInsurance]: "labels.HEALTH_INSURANCE",
  [PaySupplementAvailablePaymentTypeEnum.LifeInsurance]: "labels.LIFE_INSURANCE",
  [PaySupplementAvailablePaymentTypeEnum.SustenanceAllowance]: "labels.SUSTENANCE_ALLOWANCE",
  [PaySupplementAvailablePaymentTypeEnum.TravelAllowance]: "labels.TRAVEL_ALLOWANCE",
  [PaySupplementAvailablePaymentTypeEnum.WorkFromHomeAllowance]: "labels.WORK_FROM_HOME_ALLOWANCE",
}
